import { format } from '@cbgms/base/utils/datetime'

const useIsAmPm = () => {
  // we should find a different way to determine this, since this won't re-render.
  return format.time.endsWith('A')
}

export default useIsAmPm
